import { useState } from "react"
import { useConfigApi } from "../../api/config"

const useGetData = () => {
    const { api, baseURL } = useConfigApi()
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)

    const getData = async (url: string) => {
        setLoading(true)
        try {
            const response = await api.get(`${baseURL}${url}`)
            setData(response.data)
            return response.data
        } catch (error) {
            console.error("Error fetching data:", error)
            return null
        } finally {
            setLoading(false)
        }
    }

    return { getData, loading, data }
}

export { useGetData }